import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';


import { BaseService } from './base.service';
import { ValidationResult } from './../_models/validation-result';
import { InfoPgtoAdicional } from '../_models/InfoPgtoAdicional';
import { LogFrontFuncionalidade } from 'app/_enums/log-front-funcionalidade';
import { Operacao } from 'app/_enums/operacao';
import { MessageService } from './message.service';


@Injectable({
    providedIn: 'root'
})
export class InfoPgtoAdicionalService {

    constructor(private baseService: BaseService,
        private _msgService: MessageService) { }

    getInfoPgoAdicional(id: number): Observable<InfoPgtoAdicional | null> {
        return this.baseService.Get('get-by-num-booking/' + id).pipe(
            map((response: ValidationResult) => {
                let retorno: ValidationResult = response;

                if (retorno.IsValid)
                    return retorno.Data as InfoPgtoAdicional;
                else
                    return null;
            }), catchError(e => {
                return this.baseService.handleError(e);
            }),);
    }

    getInfoPgtoAdicionalByNumBooking(numBooking: string): Observable<InfoPgtoAdicional | null> {

        return this.baseService.Get('info-pgto-adicional/' + numBooking).pipe(
            map((response: ValidationResult) => {

                let retorno: ValidationResult = response;

                if (retorno.IsValid)
                    return retorno.Data as InfoPgtoAdicional;
                else
                    return null;
            }), catchError(e => {
                return this.baseService.handleError(e);
            }),);
    }

    getListaInfoPgtoAdicional(startDate: String, endDate: String, nomeCliente: String, cnpj: String, idBooking: String, idProposta: number): Observable<InfoPgtoAdicional[]> {

        if (idBooking == undefined)
            idBooking = '';

        if (idProposta == undefined)
            idProposta = 0;

        return this.baseService.Get('info-pgto-adicional/lista-info-pgto-adicional-by-periodo?startDate=' + startDate + '&endDate=' + endDate + '&nomeCliente=' + nomeCliente + '&cnpj=' + cnpj + '&idBooking=' + idBooking + '&idProposta=' + idProposta).pipe(
            map((response: ValidationResult) => {
                let retorno: ValidationResult = response;

                if (!retorno.IsValid) {
                    this._msgService.addMessageValidationError('Info Pagto Adicional', retorno.Erros, 'error', LogFrontFuncionalidade.InfoPgtoAdicional, Operacao.Consulta, null);
                }

                return retorno.Data as InfoPgtoAdicional[];
            }), catchError(e => {
                return this.baseService.handleError(e);
            }),);
    }
}
